module.exports = __webpack_public_path__ + "static/media/bg_pt-marcus_traningstips.94cdafb9.png";